/* Utils */
import callPhone from '@utils/callClickHandler';
import {noop} from '@utils/event';

/* Query Selector */
import {useUserCartPlanSelector, useUserIdSelector} from '@store/queries/user/useUser.selector';

/* Constants */
import {HT_INFO_PHONE} from '@constants/hellotech';
import {ICON_ORIENTATION, PLAN_IDS_FOR_PHONE_DISPLAY} from './constants';
import { useTrackingPhone } from '@store/client/store.tracking';

/* Types */
type PhoneDisplayLinkProps = {
  callClick?: BaseAnyFunction;
  displayNumber?: boolean;
  linkStyle?: string;
  icon?: React.ReactNode;
  iconOrientation?: string;
  phoneTitle?: string;
  phoneLink?: string;
};

export const PhoneDisplayLink = ({displayNumber, icon, iconOrientation, linkStyle, callClick = noop}: PhoneDisplayLinkProps) => {
  /* Client State */
  const phone = useTrackingPhone();

  let {title, link} = phone;
  const iconIsLeft = iconOrientation === ICON_ORIENTATION.left;
  const iconIsRight = iconOrientation === ICON_ORIENTATION.right;

  /* Hooks/Selectors */
  const userId = useUserIdSelector();
  const planId = useUserCartPlanSelector();

  if (!title) return null;

  if (userId && PLAN_IDS_FOR_PHONE_DISPLAY.includes(planId)) {
    link = HT_INFO_PHONE.customers.subscriptionHolder.default.link;
    title = HT_INFO_PHONE.customers.subscriptionHolder.default.title;
  }

  return (
    <a href={link} onClick={callPhone(callClick, title)} className={linkStyle} data-testid="phone-link-display">
      {iconIsLeft && icon}
      {displayNumber ? title : ''}
      {iconIsRight && icon}
    </a>
  );
};

PhoneDisplayLink.defaultProps = {
  linkStyle: null,
  iconOrientation: ICON_ORIENTATION.right,
  phoneLink: HT_INFO_PHONE.customers.default.link,
};

export default PhoneDisplayLink;
